import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { useSelectedTradingAccountId } from '@aqx-core/common/services/auth';
import { EUISnackBarMessageType, snackbarController } from '@aqx-core/common/services/snackbar';
import storage, { EStorageKey } from '@aqx-core/common/storage';

export const useAccountSwitchedSnackbar = (isShow: boolean) => {
  const { t } = useTranslation();

  const accountId = useSelectedTradingAccountId();

  useEffect(() => {
    const accountSwitched = storage.getItem(EStorageKey.ACCOUNT_SWITCHED);

    if (accountSwitched === 'true' && isShow) {
      snackbarController.showAlert({
        messageType: EUISnackBarMessageType.SUCCESS,
        message: t('You have switched your account.'),
        description: `${t('Account ID:')} ${accountId}`
      });

      storage.removeItem(EStorageKey.ACCOUNT_SWITCHED);
    }
  }, [t, accountId, isShow]);
};
